import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** Result of assigning a product to a channelled SME (PRD §3.10). */
export interface ProductAssignmentResult {
  smeId: string;
  product: string;
  assigned: boolean;
}

/**
 * DI token for the E-D Product Assignment API (PRD §3.10, EM-838). Bound to
 * `EdProductAssignmentRestService`. E-D-scoped server-side (Rule 22). REST-only (Rules 07/10).
 */
export interface EdProductAssignmentApi {
  /** POST /services/embedded/api/v1/ed/sme/{id}/products — 422 when the product is not onboarded */
  assignProduct(smeApplicationId: number, product: string): Observable<ProductAssignmentResult>;
}

export const ED_PRODUCT_ASSIGNMENT = new InjectionToken<EdProductAssignmentApi>('ED_PRODUCT_ASSIGNMENT');
